// extracted by mini-css-extract-plugin
export default {"btn":"styles_btn__YeLsB","btn__withLabel":"styles_btn__withLabel__xzAfC","btn__applied":"styles_btn__applied__fvgE9"};